define('modules/base/models/credentials.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var CredentialsModel = BaseModel.extend({
        debugName: 'CredentialsModel',
        base : 'oauth/token',
        modelErrors:{
            password_not_blank: 'Password cannot be blank.',
            username_invalid:   'The username you entered is not a valid username.',
            name_invalid:       'First name and last name are both required e.g. John Smith.',
            password_invalid:   'The password needs at least one number, one lower case letter, one uppercase letter and at least 6 characters in length.',
            accept_terms:       'The RelPro terms of use must be accepted.'
        },
        save: function(key, val, options) {
            var attrs, method, xhr, attributes = this.attributes;

            // Handle both `"key", value` and `{key: value}` -style arguments.
            if (key == null || typeof key === 'object') {
                attrs = key;
                options = val;
            } else {
                (attrs = {})[key] = val;
            }

            options = _.extend({validate: true}, options);

            // If we're not waiting and attributes exist, save acts as
            // `set(attr).save(null, opts)` with validation. Otherwise, check if
            // the model will be valid when the attributes, if any, are set.
            if (attrs && !options.wait) {
                if (!this.set(attrs, options)) return false;
            } else {
                if (!this._validate(attrs, options)) return false;
            }

            // Set temporary attributes if `{wait: true}`.
            if (attrs && options.wait) {
                this.attributes = _.extend({}, attributes, attrs);
            }

            // After a successful server-side save, the client is (optionally)
            // updated with the server-side state.
            if (options.parse === void 0) options.parse = true;
            var model = this;
            var success = options.success;
            options.success = function(resp) {
                var accessToken = resp.access_token;
                if (accessToken != null ){
                    $.ajaxSetup({
                        headers: {
                            'Authorization': 'Bearer ' + accessToken
                        },
                        crossDomain: true
                    });
                };
                window.utils.writeStorageField("accessToken", accessToken);
                model.attributes = attributes;
                var serverAttrs = model.parse(resp, options);
                if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
                if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
                    return false;
                }
                if (success) success(model, resp, options);
                model.trigger('sync', model, resp, options);
            };

            method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
            if (method === 'patch') options.attrs = attrs;
            xhr = this.sync(method, this, options);

            // Restore attributes.
            if (attrs && options.wait) this.attributes = attributes;

            return xhr;
        },
        reset: function() {
            this.errorMessage = '';
            var attrs = this.attributes;
            if (!window.utils.validation.validateEmail(attrs.email)) {
                this.modelStatus = -101;
                this.errorMessage = this.modelErrors.email_invalid;
            } else {
                this.modelStatus = 100;
            }
        },
        login: function() {
            this.errorMessage = '';
            var attrs = this.attributes;
            if (!window.utils.validation.isValidPassword(attrs.password)) {
                this.errorMessage = this.modelErrors.password_invalid;
                this.modelStatus = -101;
            }
            else if (!window.utils.validation.isValidString(attrs.username)) {
                this.errorMessage = this.modelErrors.username_invalid;
                this.modelStatus = -102;
            }
            if(this.errorMessage == '') {
                this.set({password: window.utils.validation.sha256(attrs.password)});
                this.modelStatus = 100;
            }
        },
        signup: function() {
            this.errorMessage = '';
            var attrs = this.attributes;

            if (!window.utils.validation.isValidName(attrs.name)) {
                this.errorMessage = this.modelErrors.name_invalid;
                this.modelStatus = -101;
            }
            else if (!window.utils.validation.validateEmail(attrs.email)) {
                this.errorMessage = this.modelErrors.email_invalid;
                this.modelStatus = -101;
            }
            else if (!window.utils.validation.isValidPassword(attrs.password)) {
                this.errorMessage = this.modelErrors.password_invalid;
                this.modelStatus = -101;
            } else if (!attrs.isAcceptTerms) {
                this.errorMessage = this.modelErrors.accept_terms;
                this.modelStatus = -101;
            }
            if(this.isValid()){
                this.set({password: window.utils.validation.sha256(attrs.password)});
                this.modelStatus = 100;
            }
        }
    });
    return CredentialsModel;
});

